import './RightSidebar.scss'
import { ITabItem } from '../../platform/interfaces/tab-button';
import { TabButton } from '../../platform/components/tab-button/TabButton';
import { useState } from 'react';
import { Statistics } from '../statistics/Statistics';
import { LastResults } from '../last-results/LastResults';
import { observer } from 'mobx-react';
import { userStore, useTranslation, utilsStore } from '../../platform/stores';
import { c } from '../../platform/utils';

export const RightSidebar = observer(() => {
  const t = useTranslation();
  const tabs: ITabItem[] = [
    {
      name: t('RIGHT_SIDEBAR_RESULTS'),
      value: 1,
    },
    {
      name: t('RIGHT_SIDEBAR_STATISTICS'),
      value: 2,
    }
  ];
  const [tab, setTab] = useState(1);
  const { setShowRulesModal } = utilsStore;
  const { playerExternalId, balance, currency } = userStore;

  return (
    <div className="right-sidebar">
      <div className="player">
        <div className="player-info">
          <div className="id">ID {playerExternalId}</div>
          <div className="balance">{c(balance, currency)}</div>
        </div>
        <div className="info-icon flex-center cursor-pointer" onClick={() => setShowRulesModal(true)}>i</div>
      </div>
      <div className="content">
        <TabButton tabs={tabs} onChange={(value) => setTab(value)}/>
        <div className="margin-top-10 tab-container">
          {
            tab === 1 ? <LastResults/> : <Statistics/>
          }
        </div>
      </div>
    </div>
  );
});
